import React from "react";
import DashboardLayout from "../layout/index";
import ClinicOnboardingForm from "./ClinicOnboardingForm";
import HospitalOnboardingForm from "./HospitalOnboardingForm";

const CATEGORY_CLINIC = "SC";
const CATEGORY_HOSPITAL = "HOSPI360";

export default function ClinicOnboarding() {
  const stored = localStorage.getItem("categoryType");
  const categoryType =
    !stored || stored === "null" || stored === "undefined" ? "" : stored;

  const isHospital = categoryType === CATEGORY_HOSPITAL;
  const isClinic = !isHospital && (!categoryType || categoryType === CATEGORY_CLINIC);

  const pageTitle = isHospital
    ? "Hospital Onboarding"
    : isClinic
      ? "Clinic Onboarding"
      : "Organization Onboarding";

  return (
    <DashboardLayout>
      <div className="w-full mx-auto mt-10 max-w-7xl">
        <div className="bg-gradient-to-br from-white to-[#f1f8f7] px-8 pb-8 pt-2 rounded-xl shadow-lg border border-gray-100">
          <div className="mb-4">
            <h1 className="text-xl font-semibold text-[#004276] tracking-tight">
              {pageTitle}
            </h1>
          </div>

          {isClinic && <ClinicOnboardingForm />}

          {isHospital && <HospitalOnboardingForm />}

          {!isClinic && !isHospital && (
            <div className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900">
              <p className="text-sm font-medium">
                Organization onboarding is not available for your account type
                {categoryType ? ` (${categoryType})` : ""}. Please contact your
                administrator.
              </p>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
